// Simplified Chinese. Keys omitted here fall back to English (see
// src/i18n/index.js). "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': '取消',
  'common.submit': '提交',
  'common.save': '保存',
  'common.create': '创建',
  'common.delete': '删除',
  'common.close': '关闭',
  'common.retry': '重试',
  'common.confirm': '确认',
  'common.areYouSure': '确定要继续吗？',

  'chat.startConversation': '开始对话',
  'chat.inputPlaceholder': '输入消息...',
  'chat.inputPlaceholderNoCredits': 'RPilot 额度已用完',
  'chat.creditsUsedUpFooter': '你团队的 RPilot 额度已用完。额度续订后请开始新的聊天。',
  'chat.newChat': '新聊天',
  'chat.useSkill': '使用技能',
  'chat.skills': '技能',
  'chat.loadingSkills': '正在加载技能…',
  'chat.noSkill': '不使用技能',
  'chat.noSkillsAvailable': '没有可用的技能',
  'chat.appliesNextMessage': '将从你的下一条消息开始生效',
  'chat.attachImage': '附加图片',
  'chat.attachFile': '附加文件',
  'chat.fileTooLarge': '文件太大（上限 {size}）',
  'chat.uploadFailed': '上传失败',
  'chat.download': '下载',
  'chat.recordVoice': '录制语音',
  'chat.stopRecording': '停止录音',
  'chat.stop': '停止',
  'chat.send': '发送',
  'chat.thinking': '思考中…',
  'chat.thoughtProcess': '思考过程',
  'chat.waitingForHost': '正在等待仪表板…',
  'chat.thinkingComplete': '思考完成',
  'chat.toolUsedOne': '已使用 1 个工具',
  'chat.toolsUsedCount': '已使用 {count} 个工具',
  'chat.usedNames': '已使用 {names}',
  'chat.usedToolsCount': '已使用 {count} 个工具',
  'chat.running': '运行中',
  'chat.details': '详情',
  'chat.arguments': '参数',
  'chat.result': '结果',
  'chat.error': '错误',
  'chat.done': '完成',
  'chat.openInNewTab': '在新标签页中打开',
  'chat.openInDocsSite': '在文档站点中打开',
  'chat.noPageContent': '此页面没有可用内容。',
  'chat.goodResponse': '回答得好',
  'chat.badResponse': '回答不佳',
  'chat.whatWentWrong': '哪里出了问题？',
  'chat.optionalFeedback': '可选反馈...',

  'approval.required': '需要批准',
  'approval.requiredCount': '需要批准 — {count} 项操作',
  'approval.approve': '批准',
  'approval.deny': '拒绝',
  'approval.approveAll': '全部批准',
  'approval.approveSelected': '批准所选（{count}）',
  'approval.denyAll': '全部拒绝',
  'approval.andMore': '…还有 {count} 项',
  'approval.approvedChip': '已批准',
  'approval.deniedChip': '已拒绝',
  'approval.timedOutChip': '已超时',
  'approval.countApproved': '{count} 项已批准',
  'approval.countDenied': '{count} 项已拒绝',
  'approval.countTimedOut': '{count} 项已超时',
  'approval.timedOut': '已超时',
  'approval.settled': '已处理',

  'header.expand': '展开',
  'header.collapse': '收起',
  'header.menu': '菜单',
  'drawer.sessions': '会话',
  'drawer.skills': '技能',
  'drawer.settings': '设置',
  'drawer.noSessions': '暂无会话',
  'drawer.chatFallbackTitle': '聊天 {id}',
  'drawer.newSkill': '新建技能',
  'drawer.searchSkills': '搜索技能...',
  'drawer.noSkillsMatch': '没有符合搜索条件的技能。',
  'drawer.noSkillsYet': '还没有技能。创建一个开始吧。',
  'drawer.mySkills': '我的技能',
  'drawer.builtIn': '内置',
  'drawer.shared': '已共享',
  'drawer.showToolCalls': '显示工具调用',
  'drawer.autoAcceptEdits': '自动接受编辑',
  'drawer.darkMode': '深色模式',
  'drawer.version': '版本',
  'drawer.versionCopied': '已复制',

  'gate.meetTitle': '认识 RPilot',
  'gate.meetBody': 'RPilot 是你在 RDrive 中的 AI 助手。用日常语言询问图纸、问题、进度计划和项目数据，即可获得清晰的回答以及直接跳转到应用内的链接。',
  'gate.meetCta': '想为你的团队使用 RPilot？请联系我们的销售团队',
  'gate.outOfCreditsTitle': '你的 RPilot 额度已用完',
  'gate.outOfCreditsBody': '你团队的 RPilot 额度已用完。请联系我们续订，然后从上次中断的地方继续。',
  'credits.title': '额度使用情况',
  'credits.loadFailed': '无法加载额度使用情况。',
  'credits.active': '当前',
  'credits.fallback': '备用',
  'credits.exhausted': '已用尽',
  'credits.noPools': '没有额度池',
  'credits.daily': '每日',
  'credits.weekly': '每周',
  'credits.monthly': '每月',
  'credits.dayShort': '日',
  'credits.weekShort': '周',
  'credits.monthShort': '月',
  'credits.usedNoLimit': '{label} — 已使用 {spent}（无限制）',
  'credits.balanceLine': '余额：{balance} 个额度 · 在 {zone} 午夜重置',
  'credits.account': '账户',
  'credits.scopeProject': '项目',
  'credits.scopeTeam': '团队',
  'credits.scopeMixed': '混合',
  'credits.scopePool': '额度池',
  'credits.messageNotSent': '你团队的 RPilot 额度已用完，因此无法发送此消息。你的对话已保存。',
  'credits.contactUs': '联系我们',

  'sales.contactSales': '联系销售',
  'sales.requestReceived': '已收到请求 ✓',
  'sales.submitAgain': '再次提交',
  'sales.name': '姓名',
  'sales.workEmail': '工作邮箱',
  'sales.companyTeam': '公司/团队（可选）',
  'sales.message': '留言（可选）',
  'sales.nameRequired': '请填写姓名',
  'sales.emailRequired': '请填写工作邮箱',
  'sales.emailInvalid': '请输入有效的邮箱地址',
  'sales.thanks': '谢谢——我们的团队会与你联系。',
  'sales.alreadyReceived': '我们已收到你的请求——我们会与你联系。',
  'sales.genericError': '出了点问题。请重试。',
  'sales.speakWithSales': '联系销售',
  'sales.salesChatPrefill': '您好，我想咨询为我的团队开通 RPilot 的销售事宜。',


  'skill.newSkill': '新建技能',
  'skill.editTitle': '编辑 — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': '这是由 RDrive 维护的内置技能，无法编辑。如需针对此项目进行自定义，请创建一个同名的共享技能，它将在此处优先生效。',
  'skill.name': '名称',
  'skill.nameHint': 'kebab-case 标识符',
  'skill.nameRule': '必须为 kebab-case（例如 review-rfi）',
  'skill.shared': '共享',
  'skill.description': '描述',
  'skill.descriptionPlaceholder': '这个技能的用途及使用时机',
  'skill.required': '必填',
  'skill.tags': '标签',
  'skill.tagsPlaceholder': '输入后按回车',
  'skill.allowedTools': '允许的工具',
  'skill.allToolsAllowed': '允许所有工具',
  'skill.instructions': '说明（Markdown）',
  'skill.contentRequired': '内容为必填项',
  'skill.deleteTitle': '删除技能',
  'skill.deleteMessage': '删除技能“{name}”？此操作无法撤销。',

  'picker.selectLocation': '选择位置',
  'picker.searchDrawings': '搜索图纸...',
  'picker.planViewerFailed': '无法加载图纸查看器',
  'picker.selectDrawing': '选择要查看的图纸',
  'picker.tapToPlace': '点击位置图钉以放置问题',
  'picker.pinPlaced': '已放置图钉',

  'md.bold': '粗体',
  'md.italic': '斜体',
  'md.heading': '标题',
  'md.inlineCode': '行内代码',
  'md.codeBlock': '代码块',
  'md.link': '链接',
  'md.bulletList': '项目符号列表',
  'md.numberedList': '编号列表',
  'md.blockquote': '引用',
  'md.nothingToPreview': '没有可预览的内容',
}
